import { Global } from '@emotion/react';
import { css } from '@emotion/react';
import { ReCaptchaSetting } from 'backend';
import { RE_CAPTCHA_BADGE_CSS_SELECTOR } from 'models';
import React from 'react';

type Props = {
  reCaptchaSetting?: ReCaptchaSetting;
};

const getStyles = (hideBadge: boolean) => css`
  ${RE_CAPTCHA_BADGE_CSS_SELECTOR} {
    visibility: ${(hideBadge && 'hidden') || 'visible'};
  }
`;

export const ReCaptchaGlobalStyles: React.FC<Props> = ({
  reCaptchaSetting,
}) => {
  if (!reCaptchaSetting) {
    return <Global styles={getStyles(true)} />;
  }
  const { hideBadge } = reCaptchaSetting;
  return <Global styles={getStyles(hideBadge)} />;
};
